import * as React from 'react';
import CartView from '../../components/CartView';

export default () => {
  return <CartView />;
};
